import { useEffect, useState } from 'react';

import type { LanguageIdName } from '@dec/shared';
import Env from 'env';

import translateService from './translate.sevice';

/**
 * Recupera la lista de idiomas habilitados en el sistema, con la excepción
 * del idioma actualmente en uso.
 *
 * @return {*}  {Array<string>} Lista de idiomas habilitados en el sistema excepto
 * el sistema actualmente en uso
 */
export const useTranslateList = (): Array<string> => {
  const [data, setData] = useState<Array<string>>([]);

  useEffect(() => {
    const fetchData = async () => {
      const result: Array<string> = await translateService.langList();
      const lang = Env.defaultLang;
      const list = result.filter((c: string) => c !== lang);
      setData([''].concat(list));
    };

    fetchData();
  }, []);

  return data;
};

/**
 * Recupera la totalidad de los idiomas configurados en el sistema, incluyendo
 * aquel que se encuentra configurado como idioma principal
 *
 * @return {*}  {Array<string>} Lista de idiomas
 */
export const useTranslateListAll = (): Array<LanguageIdName> => {
  const [data, setData] = useState<Array<LanguageIdName>>([]);

  useEffect(() => {
    const fetchData = async () => {
      const result: Array<string> = await translateService.langList();
      const list = result.map((c: string) => {
        return { id: c, name: c };
      });

      setData(list);
    };

    fetchData();
  }, []);

  return data;
};
